module.exports = __webpack_public_path__ + "static/item-2-8a31be3834b179daea2182089409b0f0.png";